import { Link } from "react-router-dom";

const NewsCard = ({ item }) => {
  if (!item) {
    return null; // in case no item passed
  }

  const postPath =
    item.path ||
    (item.slug && item.type ? `/insights/${item.type}/${item.slug}` : "#");

  return (
    <div className="static-card-text-wrapper">
      <div className="static-card-title">{item.title}</div>
      <div className="static-card-text">{item.intro}</div>
      <Link className="static-card-read-more" to={postPath}>
        Read More
      </Link>
    </div>
  );
};
export default NewsCard;
